import { useQuery } from '@tanstack/react-query';

import { subscriptionsQueryKeys } from '../subscriptions-qk';
import { SubscriptionsApi } from '../subscriptions.api';

export const useGetSubscriptionDetails = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: subscriptionsQueryKeys.subscriptionDetails(),
    queryFn: () => {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const result = await SubscriptionsApi.getSubscriptionDetails();
          resolve(result);
        }, 400);
      });
    },
    enabled,
  });
};
